import { API_ORIGIN } from '../config';
const API_BASE = `${API_ORIGIN}/api`;

const lineVotesService = {
  // Get all line votes
  getAll: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE}/line-votes/all`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch line votes');
    }
    
    return response.json();
  },

  // Add new line vote
  add: async (departmentCode, lineVote, festival) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE}/line-votes/add`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ departmentCode, lineVote, festival }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to add line vote');
    }
    
    return response.json();
  },

  // Delete line vote (soft delete)
  delete: async (id) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE}/line-votes/delete`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ id }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to delete line vote');
    }
    
    return response.json();
  },

  // Get deleted line votes
  getDeleted: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE}/line-votes/deletedLineVotes`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch deleted line votes');
    }
    
    return response.json();
  },

  // Restore deleted line vote
  restore: async (id) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE}/line-votes/restore`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ id }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to restore line vote');
    }
    
    return response.json();
  },
};

export default lineVotesService;
